<template>
    <form @submit.prevent="submit()">

        <base-select class="mb-4" v-if="simulation.remedial"
            :label="$t('common.log')"
            :placeholder="$t('common.log')"
            v-model="value.alt_simulation_id"
            :options="simulationsSelect"
            :filterable="true"
            :scroll="true"
            @input="errors.clear('alt_simulation_id')"
            :error="errors.get('alt_simulation_id')"
        >
        </base-select>

        <div class="mb-3 mt--4" v-if="simulation.remedial">
            <small><span class="text-warning">
                {{ $t('common.not-allowed-to-change') }}
            </span></small>
        </div>

        <div class="pt-0 mb-4">
            
            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="sortedLearners"
                    ref="learners"
                    :empty-text="$t('sessions.no-more-candidate')"
                    @select="learnerToggled">

                <el-table-column type="selection"
                    align="left"
                    min-width="120px">
                </el-table-column>

                <el-table-column width="72" class-name="avatar-cell">
                    <template v-slot="{row}">

                        <a href="#" class="avatar rounded-circle" @click.prevent="toggleLearner(row)">
                            <img alt="Image placeholder" :src="row.avatar">
                        </a>

                    </template>
                </el-table-column>

                <el-table-column class-name="name-cell">
                    <template v-slot="{row}">

                        <h4 class="mb-0">
                            <a href="#" @click.prevent="toggleLearner(row)">
                                {{ row.name }}
                            </a>
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                        <small v-if="row.entity">
                            / {{ row.entity.name }}
                        </small>

                    </template>
                </el-table-column>
                
            </el-table>
        </div>

        <div class="text-center" v-if="learners.length > 0">

            <p class="mb-4" v-if="errors.any()">
                <small class="text-danger font-weight-bold">{{ $t('sessions.invalid-learner') }}</small>
            </p>

            <base-button class="btn-primary"
                type="button"
                @click="refreshLearners"
                v-if="errors.any()"
            >
                <span class="btn-inner--text">{{ $t('sessions.refresh-learners') }}</span>
            </base-button>

            <base-button native-type="submit"
                type="primary"
                :disabled="!learner1"
                v-if="!errors.any()"
            >
                <span class="btn-inner--text">{{ $t('common.create') }}</span>
            </base-button>

            <base-button type="link" class="ml-auto" @click="modal.show = false">
                {{ $t('common.cancel') }}
            </base-button>
        </div>

    </form>
</template>

<script>
    export default {
        
        props: ['value', 'errors', 'modal', 'learners', 'simulation', 'simulations', 'paired'],

        data() {
            return {
                learner1: null,
                learner2: null
            }
        },

        watch: {

            value(session) {
                this.$refs.learners.clearSelection();

                // Learner 1.
                this.learner1 = this.learners.find(learner => learner.id == session.learner1_id)
                this.$refs.learners.toggleRowSelection(this.learner1);

                // Learner 2.
                this.learner2 = this.learners.find(learner => learner.id == session.learner2_id)
                this.$refs.learners.toggleRowSelection(this.learner2);
            }
        },

        computed: {
            
            simulationsSelect() {
                const select = {}
                for (const simulation of this.simulations) {
                    if (!simulation.assessment && !simulation.remedial) {
                        select[simulation.id] = simulation.name
                    }
                }
                return select
            },

            sortedLearners() {
                return [...this.learners].sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
            },

        },

        methods: {

            refreshLearners() {

                // Clear errors.
                this.errors.clearAll()

                // Clear all.
                this.learner1 = null
                this.learner2 = null
                this.$refs.learners.clearSelection();

                // Inform the CRUD component.
                this.$emit('refresh')
            },

            toggleLearner(learner) {

                // Clear errors.
                this.errors.clearAll()

                // Uncheck learner 1.
                if (this.learner1 && learner.id == this.learner1.id) {
                    this.learner1 = null
                    this.$refs.learners.toggleRowSelection(learner, false)

                    // Switch learners 1 and 2.
                    if (this.learner2) {
                        this.learner1 = this.learner2
                        this.learner2 = null
                    }
                    return
                }

                // Uncheck learner 2.
                if (this.learner2 && learner.id == this.learner2.id) {
                    this.learner2 = null
                    this.$refs.learners.toggleRowSelection(learner, false)
                    return
                }

                // Check learner 1
                if (!this.learner1 || !this.paired) {
                    this.$refs.learners.toggleRowSelection(this.learner1, false)
                    this.learner1 = learner
                    this.$refs.learners.toggleRowSelection(learner, true)
                    return
                }

                // Check learner 2
                if (this.paired) {
                    this.$refs.learners.toggleRowSelection(this.learner2, false)
                    this.learner2 = learner
                    this.$refs.learners.toggleRowSelection(learner, true)
                }
            },

            learnerToggled(selection) {

                // Clear errors.
                this.errors.clearAll()

                // Clear all.
                this.learner1 = null
                this.learner2 = null
                this.$refs.learners.clearSelection();

                // Keep the first.
                if (selection.length > 0) {
                    this.learner1 = selection[selection.length - 1]
                    this.$refs.learners.toggleRowSelection(this.learner1, true)
                }

                // Keep the second.
                if (this.paired && selection.length > 1) {
                    this.learner2 = selection[selection.length - 2]
                    this.$refs.learners.toggleRowSelection(this.learner2, true)
                }
            },

            submit(autoOpen = false) {
                let newValue = { ...this.value}
                newValue.learner1_id = this.learner1 ? this.learner1.id : null
                newValue.learner2_id = this.learner2 ? this.learner2.id : null
                this.$emit('autoOpen', autoOpen)
                this.$emit('input', newValue)
            }
        }
    }
</script>

<style scoped>

    form >>> .avatar-cell {
        padding-right: 0;
    }
    form >>> .name-cell {
        padding-left: 1rem;
    }
    form >>> .el-table-column--selection .el-checkbox__inner {
        border: 1px solid #a5a8ad;
    }
    form >>> .el-table__empty-text {
        line-height: 1.5rem;
        width: 80%;
    }

</style>
